export const PUBLICATION_ITEM_TYPE = {
  EVENT_BASIC: 'eventBasic',
  EVENT_SLOT: 'eventSlot',
  EVENT_TERM: 'eventTerm',
  FLOW_BASIC: 'flowBasic',
  FLOW_SLOTS: 'flowSlots',
  SESSION_BASIC: 'sessionBasic',
} as const;

export type PublicationItemType = (typeof PUBLICATION_ITEM_TYPE)[keyof typeof PUBLICATION_ITEM_TYPE];

export type BatchPublishItem =
  | { itemType: typeof PUBLICATION_ITEM_TYPE.EVENT_BASIC }
  | { itemType: typeof PUBLICATION_ITEM_TYPE.EVENT_SLOT; slotId?: string; slotIds?: string[]; allSlots?: boolean }
  | { itemType: typeof PUBLICATION_ITEM_TYPE.EVENT_TERM; termType: string }
  | { itemType: typeof PUBLICATION_ITEM_TYPE.FLOW_BASIC; flowId: string }
  | { itemType: typeof PUBLICATION_ITEM_TYPE.FLOW_SLOTS; flowId: string }
  | { itemType: typeof PUBLICATION_ITEM_TYPE.SESSION_BASIC; sessionId: string };

export type BatchPublishRequest = {
  mode?: 'PLAN' | 'ORGANIZE';
  items: BatchPublishItem[];
};

export type BatchPublishResultItem = {
  itemType: PublicationItemType;
  scopeKey: string;
  status: 'published' | 'failed';
  publishedAt?: string;
  sourceVersion?: number;
  errorMessage?: string;
};

export type BatchPublishResponse = {
  results: BatchPublishResultItem[];
};
